const commonEn = {
    common: require('../../lang/en/common/Common').default,
};

export default commonEn;